export const COMPANY_LOGO = 'https://ucarecdn.com/6d9f8564-d7e4-4cb0-9420-15050f89a914/companylogo.png'
export const SELFIE = 'https://ucarecdn.com/cf4e19c6-fa60-4f55-b27a-2c044bd6ee64/selfie.png'
export const IMAGE_404 = 'https://ucarecdn.com/86c32f8c-5f86-410e-9964-61c9ad79503c/404.png'

export const LINK_OPENING = 'https://ucarecdn.com/5198d41a-a866-4d10-9c47-214204e9b116/linkopening.png'
export const LINK_INVALID = 'https://ucarecdn.com/8c161064-a2f3-4ac6-9699-e3088040e329/linkinvalid.png'

export const GREEN_CHECK = 'https://ucarecdn.com/556e5c28-5a72-467f-afe1-11d6fefe765e/ic_green_check.png'

export const ASSET_CREATE_ACCOUNT = {
  url: 'https://ucarecdn.com/99edbce5-0a4f-4d66-a1e5-ecb4972056b3/createaccount.png',
  alt: 'Create Account for YeyPass image',
  width: '80%',
  height: 'auto'
}

export const ASSET_CREATE_ACCOUNT_2 = {
  url: 'https://ucarecdn.com/4d88d755-652a-44bb-a22b-89093092166e/createaccount2.png',
  alt: 'Set Access Instructions for YeyPass image',
  width: '80%',
  height: 'auto'
}

export const ASSET_CREATE_PROFILE_1 = {
  url: 'https://ucarecdn.com/7a5b6768-df85-4476-ad4f-2a44129fb83d/createprofile01.png',
  alt: 'Set Profile for YeyPass image',
  width: '80%',
  height: 'auto'
}

export const ASSET_CREATE_PROFILE_2 = {
  url: 'https://ucarecdn.com/dc70b457-02fb-4ce4-bc1d-b091cac1fbbb/createprofile02.png',
  alt: 'Set Building Details for YeyPass image',
  width: '80%',
  height: 'auto'
}

export const ASSET_REQUEST_DEMO = {
  url: 'https://ucarecdn.com/556b62c6-03a5-4ecc-83c8-2dcde93750f3/requestdemo.png',
  alt: 'Request for a demo for YeyPass image',
  width: '80%',
  height: 'auto'
}



// WEBPACK FOOTER //
// ./src/api/constants/ImageAssets.js